import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { LanguageOption } from "../types";
import { SiteLocales } from "../../../../../../common/enums";
import { ChangeEvent } from "react";

type Props = {
  options: LanguageOption[];
  onLanguageChange: (locale: SiteLocales) => void;
  selectedLanguage: LanguageOption;
};

export const LanguageSelector = ({ options, onLanguageChange, selectedLanguage }: Props) => {
  const handleRadioChange = (e: ChangeEvent<HTMLInputElement>) => {
    onLanguageChange(e.target.value as SiteLocales);
  };

  return (
    <FormControl>
      <RadioGroup data-testid="language-selector-group" onChange={handleRadioChange} name="radio-buttons-group" sx={{ marginTop: "5px", marginBottom: "-8px" }}>
        {options.map(({ title, code }) => {
          return (
            <FormControlLabel
              key={code}
              checked={selectedLanguage.code === code}
              value={code}
              control={<Radio sx={{ padding: "5px 7px" }} name={code} size={"small"} />}
              label={<span>{title}</span>}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
};
